import { useState, useMemo } from 'react';
import { CustomerData } from 'src/shared/services/interfacev2';

export const useCustomerSearch = (customers: CustomerData[] = [], showDeleted: boolean) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchError, setSearchError] = useState('');

  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) return customers;

    const cleanedValue = searchTerm
      .replace(/[!@#$%^&?*<>|/{}():_+=";'.,[\]`-]/g, '')
      .toLowerCase()
      .trim();

    const filtered = customers.filter((item) => {
      const phoneNumberMatch = item.phones?.[0]?.phone?.toLowerCase().includes(cleanedValue);
      const alternativePhoneMatch = item.phones?.[1]?.phone?.toLowerCase().includes(cleanedValue);
      const nameMatch = item.firstName?.toLowerCase().includes(cleanedValue);
      return phoneNumberMatch || alternativePhoneMatch || nameMatch;
    });

    if (filtered.length === 0) {
      setSearchError(showDeleted ? 'No deleted customers available' : 'No active customers available');
    } else {
      setSearchError('');
    }

    return filtered;
  }, [customers, searchTerm, showDeleted]);

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  return { searchTerm, filteredData, searchError, handleSearch };
};